import getElementHeight from 'DOM/getElementHeight';
import scrollToCoordinates from './scrollToCoordinates';

const selectors = {
  header: '#shopify-section-header',
};

const scrollToElement = (element, extraElement = null) => {
  const header = document.querySelector(selectors.header);

  if (!header || !element) return;

  let extraElementHeight = 0;
  let correction = 0;
  if (extraElement) {
    extraElementHeight = getElementHeight(extraElement);
  }
  // Subscription page correction for fixed progress bar/header jump
  if (element.getAttribute('data-form-step') === '1') {
    correction = 200;
  }

  const headerHeight = getElementHeight(header);
  const elementYOffset = window.pageYOffset + element.getBoundingClientRect().top;
  const yCoordinate = elementYOffset - headerHeight - extraElementHeight - correction;

  scrollToCoordinates(0, yCoordinate);
};

export default scrollToElement;
